// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"c23ace91","453":"df8ce626"}[chunkId] + ".chunk.js";
};